import { Component, ViewChild,  OnInit} from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertController, NavController, NavParams, ModalController,LoadingController } from '@ionic/angular';

import { Stylist } from '../../models/stylist/stylist.model';
import { SocialMediaLinks } from '../../models/social-media-links/social-media-links.model';
import { SocialMediaLinksService } from '../../services/social-media-links.service';
import { UserService } from '../../services/user.service';
import { Utilities } from '../../utilities/utilities';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-social-media-settings',
  templateUrl: './social-media-settings.page.html',
  styleUrls: ['./social-media-settings.page.scss'],
})
export class SocialMediaSettingsPage {

  
  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  //@ViewChild(Content) content: Content;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStylistSocialMediaLinks: boolean;

  public submitted: boolean;

  public savingInProgress: boolean;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public socialMediaLinks: SocialMediaLinks;

  public socialMediaSettingsForm: UntypedFormGroup;

  public facebookField: UntypedFormControl;

  public twitterField: UntypedFormControl;

  public instagramField: UntypedFormControl;

  public googlePlusField: UntypedFormControl;

  public pinterestField: UntypedFormControl;

  public tumblrField: UntypedFormControl;

  public yelpField: UntypedFormControl;

  constructor (private navCtrl: NavController,
              private alertCtrl: AlertController,
              private socialMediaLinksService: SocialMediaLinksService,
              private userService: UserService,
              private formBuilder: UntypedFormBuilder,
              private readonly alertService: AlertService,
              private loadingCtrl: LoadingController,
              private readonly toastService: ToastService,
              private router: Router) {
    this.isLoading = true;
    this.submitted = false;
    this.savingInProgress = false;
    this.facebookField = new UntypedFormControl('', Validators.maxLength(100));
    this.twitterField = new UntypedFormControl('', Validators.maxLength(100));
    this.instagramField = new UntypedFormControl('', Validators.maxLength(100));
    this.googlePlusField = new UntypedFormControl('', Validators.maxLength(100));
    this.pinterestField = new UntypedFormControl('', Validators.maxLength(100));
    this.tumblrField = new UntypedFormControl('', Validators.maxLength(100));
    this.yelpField = new UntypedFormControl('', Validators.maxLength(100));
    this.socialMediaSettingsForm = this.formBuilder.group({
      facebook: this.facebookField,
      twitter: this.twitterField,
      instagram: this.instagramField,
      googleplus: this.googlePlusField,
      pinterest: this.pinterestField,
      tumblr: this.tumblrField,
      yelp: this.yelpField
    });

    this.readOnlyStylistPicker = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator()) {
        this.readOnlyStylistPicker = false;
      }
    }
  }

 
  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
     // this.content.resize();
    }
  }

  public onTapToReload () {
    this.isLoading = true;

    if (this.errorOccurredWhileLoadingStylistSocialMediaLinks) {
      this.errorOccurredWhileLoadingStylistSocialMediaLinks = false;
      this.onStylistSelect(this.stylist);
    } else if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();      
    }
  }

  public onStylistSelect (stylist: Stylist) {
    if (stylist) {
      this.isLoading = true;
      this.errorOccurredWhileLoadingStylistSocialMediaLinks = false;
      this.socialMediaSettingsForm.reset();
      this.stylist = stylist;
      this.stylistID = this.stylist.getID();

      // load the social media links
      this.socialMediaLinksService.getStylistSocialMediaLinks(this.stylist.getID())
      .subscribe({
        next: (data: SocialMediaLinks) => {
          this.socialMediaLinks = data;
              this.facebookField.setValue(this.socialMediaLinks.getFacebook());
              this.twitterField.setValue(this.socialMediaLinks.getTwitter());
              this.instagramField.setValue(this.socialMediaLinks.getInstagram());
              this.googlePlusField.setValue(this.socialMediaLinks.getGoogleplus());
              this.pinterestField.setValue(this.socialMediaLinks.getPinterest());
              this.tumblrField.setValue(this.socialMediaLinks.getTumblr());
              this.yelpField.setValue(this.socialMediaLinks.getYelp());
              this.isLoading = false;
        },
        error: (e) => {
          this.isLoading = false;
              this.errorOccurredWhileLoadingStylistSocialMediaLinks = true;
              this.alertService.presentErrorAlert();
             // this.content.resize();
        }      
      });

    }
  }

  public async onSocialMediaLinksFormSave () {
    this.submitted = true;

    if (this.socialMediaSettingsForm.valid === false) {
      return;
    }
    
    this.savingInProgress = true;
    this.socialMediaLinks = this.socialMediaLinks.setFacebook(this.facebookField.value);
    this.socialMediaLinks = this.socialMediaLinks.setTwitter(this.twitterField.value);
    this.socialMediaLinks = this.socialMediaLinks.setInstagram(this.instagramField.value);
    this.socialMediaLinks = this.socialMediaLinks.setGoogleplus(this.googlePlusField.value);
    this.socialMediaLinks = this.socialMediaLinks.setPinterest(this.pinterestField.value);
    this.socialMediaLinks = this.socialMediaLinks.setTumblr(this.tumblrField.value);
    this.socialMediaLinks = this.socialMediaLinks.setYelp(this.yelpField.value);

    //const loader = this.loadingCtrl.create({spinner: 'crescent'});
        const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
    this.socialMediaLinksService.saveSocialMediaLinks(this.stylist.getID(), this.socialMediaLinks)
    .subscribe({
      next: (stylist) => {
        loader.dismiss().then(() => {
          this.savingInProgress = false;
          //this.navCtrl.pop();
          this.router.navigateByUrl('settings');
        });
      },
      error: (e) => {
        loader.dismiss().then(() => {
          this.savingInProgress = false;
          this.alertService.presentErrorAlert();
        });
      }      
    });
  }

  public onBack () {
    //this.navCtrl.pop();
    this.router.navigateByUrl('settings');
  }
}
